import * as t from 'io-ts';
import { detailCodec, formCodec, listCodec, recordCodec } from '@/services/api/resources/sensor';

export type Sensor = t.TypeOf<typeof formCodec>;
export type SensorRecord = t.TypeOf<typeof recordCodec>;
export type SensorList = t.TypeOf<typeof listCodec>;
export type SensorDetail = t.TypeOf<typeof detailCodec>;

//we do not multiply 1 and 5 by 60 anymore.
export const DEFAULT_GRANULARITY = 300;
